import { MotionGlobalConfig } from '../utils/GlobalConfig.mjs';
import { createRenderStep } from './render-step.mjs';
var stepsOrder = ["read",
// Read
"resolveKeyframes",
// Write/Read/Write/Read
"update",
// Compute
"preRender",
// Compute
"render",
// Write
"postRender" // Compute
];
var maxElapsed = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
  var runNextFrame = false;
  var useDefaultElapsed = true;
  var state = {
    delta: 0.0,
    timestamp: 0.0,
    isProcessing: false
  };
  var flagRunNextFrame = function flagRunNextFrame() {
    return runNextFrame = true;
  };
  var steps = stepsOrder.reduce(function (acc, key) {
    acc[key] = createRenderStep(flagRunNextFrame);
    return acc;
  }, {});
  var read = steps.read,
    resolveKeyframes = steps.resolveKeyframes,
    update = steps.update,
    preRender = steps.preRender,
    render = steps.render,
    postRender = steps.postRender;
  var processBatch = function processBatch() {
    var timestamp = MotionGlobalConfig.useManualTiming ? state.timestamp : performance.now();
    runNextFrame = false;
    state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
    state.timestamp = timestamp;
    state.isProcessing = true;
    // Unrolled render loop for better per-frame performance
    read.process(state);
    resolveKeyframes.process(state);
    update.process(state);
    preRender.process(state);
    render.process(state);
    postRender.process(state);
    state.isProcessing = false;
    if (runNextFrame && allowKeepAlive) {
      useDefaultElapsed = false;
      scheduleNextBatch(processBatch);
    }
  };
  var wake = function wake() {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!state.isProcessing) {
      scheduleNextBatch(processBatch);
    }
  };
  var schedule = stepsOrder.reduce(function (acc, key) {
    var step = steps[key];
    acc[key] = function (process) {
      var keepAlive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!runNextFrame) wake();
      return step.schedule(process, keepAlive, immediate);
    };
    return acc;
  }, {});
  var cancel = function cancel(process) {
    for (var i = 0; i < stepsOrder.length; i++) {
      steps[stepsOrder[i]].cancel(process);
    }
  };
  return {
    schedule: schedule,
    cancel: cancel,
    state: state,
    steps: steps
  };
}
export { createRenderBatcher, stepsOrder };